import { PublicationElement } from '@/types/models';

export const isReactionElement = (element: PublicationElement): boolean => {
  return element.reactionId !== undefined && element.reactionId !== null;
};
